{
	"name": "pastalacabra-playground",
	"version": "2.16.0",
	"description": "Pastalacabra Playground",
	"author": "Gonzalo Zas",
	"license": "ISC"
}
